module.exports = __webpack_public_path__ + "platform/static/media/done.52683d66.svg";